import { render, staticRenderFns } from "./BaseHeading.vue?vue&type=template&id=5200087d"
import script from "./BaseHeading.vue?vue&type=script&lang=js"
export * from "./BaseHeading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports